<template>
  <div>
    <router-link to="/admin"><a>Admin</a></router-link>
    
  </div>
</template>

<script>
export default {
  name: 'layout-admin-header',

}
</script>
